import React from 'react';
import {Form, Spinner} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {useGetAdressesBySiret} from '../Hooks/DivopsHooks';
import {AdresseSuggestion} from '../Types/types';

interface SiretAdresseSelectProps {
  siret: string;
  onSelect: (suggestion: AdresseSuggestion, societe?: string) => void;
}

const SiretAdresseSelect = ({siret, onSelect}: SiretAdresseSelectProps): JSX.Element | null => {
  const intl = useIntl();
  const {data, isFetching, isError} = useGetAdressesBySiret(siret);

  if (siret.length !== 14) {
    return null;
  }

  if (isFetching) {
    return (
      <div className="d-flex align-items-center mt-2">
        <Spinner animation="border" size="sm" className="me-2" />
        {intl.formatMessage({id: 'WAIT'})}
      </div>
    );
  }

  if (isError || !data || data.suggestions.length === 0) {
    return (
      <div className="text-muted fs-8 mt-2">
        {intl.formatMessage({id: 'DIVOPS.CLIENT.ADRESSE.SIRET_SELECT.NOT_FOUND'})}
      </div>
    );
  }

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const suggestion = data.suggestions[Number(e.target.value)];
    if (suggestion) {
      onSelect(suggestion, data.societe);
    }
  };

  return (
    <Form.Select className="form-select-solid mt-2" defaultValue="" onChange={handleChange}>
      <option value="" disabled>
        {intl.formatMessage({id: 'DIVOPS.CLIENT.ADRESSE.SIRET_SELECT.PLACEHOLDER'})}
      </option>
      {data.suggestions.map((suggestion, index) => (
        <option key={`${suggestion.codeInsee}-${suggestion.label}-${index}`} value={index}>
          {suggestion.label}
        </option>
      ))}
    </Form.Select>
  );
};

export default SiretAdresseSelect;
